const Type = 'soft-break';
const SoftBreakPlugin = ({
  insertLineBreak = defaultInsertLineBreakHandler,
  replaceNewLinesWithBreaks = true
} = {
  insertLineBreak: defaultInsertLineBreakHandler,
  replaceNewLinesWithBreaks: true
}) => ({
  type: Type,
  onKeyDown(event, editor) {
    if (insertLineBreak(event)) {
      event.preventDefault();
      editor.insertText('\n');
    }
  },
  deserialize: {
    text: [{
      deserialize(node) {
        if (node instanceof HTMLElement && node.nodeName === 'BR' &&
        // Google Docs adds classNames to trailing line breaks
        node.classList.length === 0) {
          return '\n';
        }
        return undefined;
      }
    }]
  },
  serialize: {
    leaf(props) {
      return replaceNewLinesWithBreaks ? replaceNewLines(props.children) : props.children;
    }
  }
});
function replaceNewLines(string) {
  return string.replace(/\r?\n|\r/g, '<br/>');
}
function defaultInsertLineBreakHandler(event) {
  return event.key === 'Enter' && event.shiftKey;
}

export { SoftBreakPlugin, Type, defaultInsertLineBreakHandler };
